module.exports = __webpack_public_path__ + "img/referra-pro-app-logo-305x104.71403e63.png";